import React, { useState, useContext, useEffect, useRef } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { FOOTER_LOGO, SITE_URL, SITE_NAME } from '@/utils'
import { Link, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import { Badge, Button, Divider, ListItem, SwipeableDrawer } from '@material-ui/core'
import AuthContext from '@/product/context/auth/authContext'
import CommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '../../../context/common/commonContext'
import AlertContext from '@/product/context/alert/alertContext'
import { handleRedirectInternal } from '@/product/common/components'
import './Header.css'
import BuynowContext from '@/product/context/buynow/buynowContext'
import PayContext from '@/product/context/payment/payContext'
import FooterLinks from '../Footer/footerLinks'
import { footerData } from '../Footer/footerData'
import { Popover } from '@material-ui/core'
import Nav from '@/custom/components/atoms/Nav'
import NavItem from '@/custom/components/atoms/NavItem'
import { menuList, authList } from '@/utils/common'
import { socket } from '@/product/common/socket'
import { Autocomplete } from './autocomplete'
import { getAlgoliaResults } from '@algolia/autocomplete-js'
import algoliasearch from 'algoliasearch'
import SignContext from '@/custom/context/signContext'
import LocationSelector from '@/custom/common/LocationSelector'
import CustomDialog from '../../organisms/CustomDialog'
import QRCode from 'react-qr-code'
import { LOGO } from '@/utils/index'

const MobileHeader = ({
    locationValue,
    locationData,
    handleLocationValue,
    handleSearchAutocompleteTextChange,
    handleScanProduct,
}) => {
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const commonContext = useContext(CommonContext)
    const customCommonContext = useContext(CustomCommonContext)
    const payContext = useContext(PayContext)
    const buynowContext = useContext(BuynowContext)
    const [isSubmit, setIsSubmit] = useState(false)
    const [openLocation, setOpenLocation] = useState(false)
    const [locationName, setLocationName] = useState('Select Location')
    const [cityName, setCityName] = useState('')

    const pathLocation = useLocation()

    const { setAlert } = alertContext
    const {
        user,
        isAuthenticated,
        cartCount,
        logout,
        login,
        responseStatus: responseStatusAuth,
    } = authContext

    const [state, setState] = useState({
        right: false,
        top: false,
    })

    const formik = useFormik({
        initialValues: {
            user: '',
        },
        onSubmit: (values) => {},
    })
    const history = useHistory()
    const [anchormenu, setanchormenu] = useState(null)
    const [anchorcart, setanchorcart] = useState(null)
    const [headerMenus, setHeaderMenus] = useState([])

    const { responseStatus: responseStatusPayment } = payContext

    const { search_allproducts } = buynowContext

    const { searchValue, setSearchValue, isLoading } = commonContext
    const { setCurrentMembership, allBiddingPlan, membership, allHeaderMenus } = customCommonContext
    const [searchText, setSearchText] = useState('')
    let [cartProducts, setCartProducts] = useState([])
    const [headerSearch, setHeaderSearch] = useState(false)

    const [socketDisconnect, setSocketDisconnect] = useState(false)
    const { handleLoginPopup, handleRegisterPopup } = useContext(SignContext)
    const [qrCodePopup, setQrCodePopup] = useState(false)
    const switch_user = [
        {
            placeholder: 'Switch User',
            class: 'col-12 pl-0 switchUserDD',
            type: 'select',
            variant: 'standard',
            options: [
                { value: 'user1', show: 'User-Seller' },
                { value: 'user2', show: 'User-Buyer' },
            ],
            name: 'user',
            formik: formik,
        },
    ]

    const watchlistFilter = {
        table: 'watchlists',
        field: 'w.id',
        havingCount: true,
        aliasName: 'watchlist',
        extraField: '',
        filters: {
            paid: {
                value: '0',
                type: 'in',
                field: 'w.is_delete',
            },
            active: {
                value: 'open',
                type: 'in',
                field: 'p.market_status',
            },
        },
        tableJoins: [
            {
                baseTable: 'projects',
                joinType: 'inner',
                baseJoinField: 'id',
                connectJoinField: 'project_id',
            },
        ],
    }

    const buyNowFilter = {
        table: 'cart_temp',
        field: 'cart_id',
        havingCount: true,
        extraField: '',
        filters: {
            paid: {
                value: '0',
                type: 'in',
                field: 'crt.paid',
            },
        },
    }

    useEffect(() => {
        if (socket) {
            socket.on('connect', () => {
                setSocketDisconnect(false)
            })
            socket.on('disconnect', () => {
                setSocketDisconnect(true)
            })
        }
    }, socket)

    useEffect(() => {
        if (formik.values.user) {
            if (formik.values.user === 'user1') {
                login({
                    email: 'abdul.auctionsoftware@gmail.com',
                    password: '12345678',
                })
            } else if (formik.values.user === 'user2') {
                login({
                    email: 'sara@auctionsoftware.com',
                    password: '12345678',
                })
            }
        }
        if (!isAuthenticated) {
            formik.values.user = ''
        }
    }, [formik.values.user, isAuthenticated])

    useEffect(() => {
        if (isAuthenticated) {
            if (user) {
                if (user.membership) {
                    if (allBiddingPlan && allBiddingPlan.length) {
                        let activePlan = allBiddingPlan.filter(
                            (value) => value.type === user.membership,
                        )
                        if (activePlan.length) {
                            setCurrentMembership(activePlan[0])
                        } else {
                            setCurrentMembership('')
                        }
                    }
                }
            }
        }
    }, [isAuthenticated, user, allBiddingPlan])

    useEffect(() => {
        setCartProducts(search_allproducts.cartrecords.length ? search_allproducts.cartrecords : [])
    }, [search_allproducts])

    useEffect(() => {
        setCartProducts([])
        return () => {
            setCartProducts([])
        }
    }, [])

    const changeQrPopupStatus = () => {
        setQrCodePopup(!qrCodePopup)
    }

    useEffect(() => {
        if (responseStatusAuth) {
            if (responseStatusAuth.status === 'success') {
                handleRedirectInternal(history, '')
            }
        }
    })

    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.from === 'payment') {
                if (responseStatusPayment.status === 'success') {
                    if (responseStatusPayment.data && responseStatusPayment.data.url) {
                        const newWindow = window.open(
                            responseStatusPayment.data.url,
                            '_self',
                            'noopener,noreferrer',
                        )
                        if (newWindow) newWindow.opener = null
                    }
                }
            }
        }
    }, [responseStatusPayment])

    useEffect(() => {
        if (searchValue) {
            handleRedirectInternal(history, `search`)
        }
    }, [searchValue])

    const handleHeaderTopSearch = () => {
        setHeaderSearch(!headerSearch)
    }
    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }

    const onLogOut = () => {
        localStorage.getItem('locationUpdated')
        localStorage.removeItem('user_added')
        logout()
        toggleDrawer('right', false)()
        setAlert('Logged out successfully', 'success')
        handleRedirectInternal(history, '')
        setanchormenu(null)
        setanchorcart(null)
        setSearchText('')
    }

    const handleCart = (event) => {
        setanchorcart(event.currentTarget)
    }
    const handleMenu = (event) => {
        setanchormenu(event.currentTarget)
    }

    const handleClose = (history, path) => {
        setanchormenu(null)
        setanchorcart(null)
        if (history && path && path !== 'backdropClick') {
            handleRedirectInternal(history, path)
        }
    }

    const getSearchBarObjet = (value) => {
        return {
            limit: 12,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            filters: {
                searchbar: {
                    value: value,
                    type: 'like',
                    field: 'p.title,p.desc_proc',
                },
            },
        }
    }

    const handleSearchTextChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleSearchButtonClick = () => {
        setSearchValue(getSearchBarObjet(searchText))
        setState({ ...state, top: false })
        if (location.pathname != '/search') {
            handleRedirectInternal(history, 'search')
        }
    }

    const handleLocation = () => setOpenLocation(!openLocation)

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            setSearchValue(getSearchBarObjet(searchText))
            if (location.pathname != '/search') {
                handleRedirectInternal(history, 'search')
            }
        }
    }

    useEffect(() => {
        if (searchValue && searchValue.filters && searchValue.filters.searchbar) {
            setSearchText(searchValue.filters.searchbar.value)
        }
    }, [searchValue])

    const [count, setCount] = useState({
        bidsCount: 0,
        buynowCount: 0,
        watchlistCount: 0,
    })

    useEffect(() => {
        if (cartCount?.bidsCount) {
            setCount({ ...count, bidsCount: cartCount.bidsCount.totalRecords })
        }
        if (cartCount?.buynowCount) {
            setCount({ ...count, buynowCount: cartCount.buynowCount.totalRecords })
        }
        if (cartCount?.watchlistCount) {
            setCount({ ...count, watchlistCount: cartCount.watchlistCount.totalRecords })
        }
    }, [cartCount])

    const appId = process.env.REACT_APP_ALGOLIA_APPID
    const apiKey = process.env.REACT_APP_ALGOLIA_APIKEY
    const searchClient = algoliasearch(appId, apiKey)

    useEffect(() => {
        if (allHeaderMenus?.length) {
            setHeaderMenus(allHeaderMenus.filter((menu) => menu.type === 'header'))
        }
    }, [allHeaderMenus])

    const UrlCheck = window.location.pathname == '/search' || window.location.pathname == '/'

    const [scrolled, setScrolled] = useState(null)

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 25) {
                // console.log(window.scrollY, '@@window.scrollY')
                setTimeout(() => {
                    setScrolled(true) // Add class when scrolled
                }, 100)
            } else {
                setTimeout(() => {
                    setScrolled(false) // Remove class when at the top
                }, 100)
            }
        }

        window.addEventListener('scroll', handleScroll)

        // Cleanup function
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, []) // Empty dependency array to run only on mount

    const handleFocus = () => {
        document.body.classList.add('algolia-active')
    }

    const handleListSearch = () => {
        localStorage.setItem('clearSearch', true)
    }

    const orderbyHeader = [
        { id: 18, label: "Today's Steals", href: 20 },
        { id: 21, label: 'Popular', href: 21 },
    ]

    useEffect(() => {
        const paramsSearch = new URLSearchParams(window.location.search)
        const searchValue = paramsSearch.get('searchbar') // only check 'searchbar'

        if (!searchValue) {
            // If 'searchbar' is missing or empty
            setSearchText('')
        }
    }, [window?.location?.search])

    return (
        <>
            {/* MOBILE / TAB NAVIGATION */}
            <header className="mainHeader noPrint">
                <div className={`customContainer header-wrapper`}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="headLt d-flex justify-content-start">
                            <Link to="/">
                                <img src={FOOTER_LOGO} alt={SITE_NAME} width="156" height="47" />
                            </Link>
                        </div>
                        <div className="headRt mobile-menu">
                            <ul>
                                {!isAuthenticated && (
                                    <li className="authDiff ">
                                        <div className="headerAuthText d-flex align-items-center justify-content-center">
                                            <NavLink
                                                to="#"
                                                onClick={handleLoginPopup}
                                                ActiveclassName="active"
                                                id="header_login"
                                                className="pr-0"
                                            >
                                                Login
                                            </NavLink>
                                            <span className="position-relative mx-1 slash"></span>
                                            <NavLink
                                                to="#"
                                                className="pl-0"
                                                onClick={handleRegisterPopup}
                                                ActiveclassName="active"
                                                id="header_register"
                                            >
                                                Register
                                            </NavLink>
                                        </div>
                                    </li>
                                )}
                                <li>
                                    <Button id="header_user_search" onClick={handleHeaderTopSearch}>
                                        <span className="material-icons">search</span>
                                    </Button>
                                </li>
                                {/* {isAuthenticated ? (
                                    <>
                                        <li className="">
                                            <Link to="/watchlist/watchlist">
                                                <Badge badgeContent="0" color="primary">
                                                    <img src="/assets/svg/heart.svg" alt="" />
                                                </Badge>
                                            </Link>
                                        </li>
                                        <li className="">
                                            <NavLink to="/cart" ActiveclassName="active">
                                                <span className="material-icons">shopping_cart</span>
                                            </NavLink>
                                        </li>
                                    </>
                                ) : null} */}
                                {/* {isAuthenticated ? (
                                    <li>
                                        <Button
                                            id="header_user_detail"
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            onClick={toggleDrawer('right', true)}
                                        >
                                            <span className="userInitials small">
                                                {user?.first_name?.charAt(0)}
                                                {user?.last_name?.charAt(0)}
                                            </span>
                                        </Button>
                                    </li>
                                ) : null} */}

                                {isAuthenticated ? (
                                    user?.admin ? (
                                        ''
                                    ) : (
                                        <>
                                            <li>
                                                <Button
                                                    id="header_user_search"
                                                    onClick={() => setQrCodePopup(true)}
                                                >
                                                    <span className="material-icons">
                                                        qr_code_2
                                                    </span>
                                                </Button>
                                            </li>
                                            <li>
                                                <Button
                                                    aria-controls="simple-cart"
                                                    aria-haspopup="true"
                                                    id="header_cart"
                                                    onClick={() =>
                                                        handleRedirectInternal(history, 'cart')
                                                    }
                                                >
                                                    <Badge
                                                        badgeContent={count.buynowCount}
                                                        color="primary"
                                                    >
                                                        <img
                                                            src="/assets/svg/shopping-cart.svg"
                                                            alt=""
                                                        />
                                                    </Badge>
                                                </Button>
                                                {/* <Popover
                                                    anchorEl={anchorcart}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    }}
                                                    id="simple-cart"
                                                    keepMounted
                                                    class={`headerDropMenu ${
                                                        document.body.dir === 'rtl' && 'rtl'
                                                    }`}
                                                    open={Boolean(anchorcart)}
                                                    onClose={handleClose}
                                                >
                                                    <ul
                                                        className={`headerDropMenu ${
                                                            document.body.dir === 'rtl' && 'rtl'
                                                        }`}
                                                    >
                                                        <ListItem
                                                            button
                                                            onClick={() =>
                                                                handleClose(history, 'buynowcart')
                                                            }
                                                            id="header_buynowcart"
                                                        >
                                                            <Badge
                                                                badgeContent={count.buynowCount}
                                                                color="primary"
                                                            >
                                                                <span className="material-icons">
                                                                    shopping_bag
                                                                </span>
                                                            </Badge>
                                                            {'Buy now cart'}
                                                        </ListItem>
                                                        <ListItem
                                                            button
                                                            onClick={() => handleClose(history, 'cart')}
                                                            id="header_auctioncart"
                                                        >
                                                            <Badge
                                                                badgeContent={count.auctionCount}
                                                                color="primary"
                                                            >
                                                                <span className="material-icons">
                                                                    gavel
                                                                </span>
                                                            </Badge>

                                                            {'Won Items'}
                                                        </ListItem>
                                                    </ul>
                                                </Popover> */}
                                            </li>
                                        </>
                                    )
                                ) : null}
                                <li>
                                    <Button
                                        className="respNavBtn"
                                        id="header_menu"
                                        onClick={toggleDrawer('right', true)}
                                    >
                                        <span className="material-icons">menu</span>
                                    </Button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {headerSearch && (
                        <div className="respHeaderSearch">
                            <div
                                className={`form-inline my-lg-0 headerSearchForm ${
                                    isSubmit && 'asdasd'
                                }`}
                            >
                                <button
                                    onClick={() => handleSearchAutocompleteTextChange(searchText)}
                                    className="search-icon"
                                >
                                    <img src="/assets/svg/search.svg" />
                                </button>
                                <input
                                    type="text"
                                    onChange={(e) => setSearchText(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearchAutocompleteTextChange(searchText)
                                        }
                                    }}
                                    value={searchText || ''}
                                />
                                <button
                                    onClick={() => (handleScanProduct ? handleScanProduct() : null)}
                                    className="barcode-scanner"
                                >
                                    <span className="material-icons">qr_code_scanner</span>
                                </button>
                                {/* <button
                                    onClick={() => {
                                        setSearchText('')
                                        handleSearchAutocompleteTextChange('', 1)
                                    }}
                                    className="clear-icon"
                                >
                                    <img src="/assets/svg/closeIcon.svg" />
                                </button> */}
                                {/* <Autocomplete
                                    value={searchText}
                                    detachedMediaQuery={false}
                                    openOnFocus={true}
                                    onFocus={handleFocus}
                                    onSubmit={(stateData) => {
                                        stateData.setIsOpen(false)
                                        handleSearchAutocompleteTextChange(stateData, false)
                                    }}
                                    getSources={({ query }) => [
                                        {
                                            sourceId: 'products',
                                            onSelect({ setIsOpen, setQuery, event, item }) {
                                                handleRedirectInternal(
                                                    history,
                                                    `productview/${item?.objectID}`,
                                                )
                                            },
                                            getItems() {
                                                return getAlgoliaResults({
                                                    searchClient,
                                                    queries: [
                                                        {
                                                            indexName:
                                                                process.env.REACT_APP_ALGOLIA_INDEX,
                                                            query,
                                                        },
                                                    ],
                                                })
                                            },
                                            templates: {
                                                header() {
                                                    return 'Suggestions'
                                                },
                                                // setIsSubmit(true),
                                                item({ item, components }) {
                                                    return (
                                                        <div className="aa-Item">
                                                            {item?.objectID ? (
                                                                <div className="aa-ItemTitle">
                                                                    <components.Highlight
                                                                        hit={item}
                                                                        attribute="title"
                                                                    />
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    )
                                                },
                                            },
                                        },
                                    ]}
                                /> */}
                                <Button
                                    id="header_searchButton"
                                    className="clear-icon btn"
                                    onClick={() => {
                                        handleHeaderTopSearch()
                                        setSearchText('')
                                        handleSearchAutocompleteTextChange('', 1)
                                    }}
                                >
                                    <span className="material-icons">close</span>
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
                <div className={scrolled ? 'setFixed' : null}>
                    <Nav
                        menuClass={`${
                            // window.location.pathname == '/search'
                            //     ? 'container-fluid'
                            // :
                            'customContainer'
                        }`}
                    >
                        <NavLink
                            key={`nav-Seach Page`}
                            to={'/search'}
                            onClick={() => handleListSearch()}
                        >
                            All Listings
                        </NavLink>

                        {orderbyHeader.map((item) => (
                            <>
                                <NavLink key={`nav-${item.id}`} to={`/search?orderby=${item.href}`}>
                                    {item.label}
                                </NavLink>
                            </>
                        ))}

                        {headerMenus?.map((list) => (
                            <>
                                {list?.type === 'header' ? (
                                    list.menu_type === 'tag' ? (
                                        <NavLink
                                            key={`nav-${list.id}`}
                                            to={`/search?keywords=${list?.menu_value || ''}`}
                                        >
                                            {list.menu_name}
                                        </NavLink>
                                    ) : (
                                        <a
                                            key={`nav-${list.id}`}
                                            href={`${list?.menu_value || '#'}`}
                                        >
                                            {list.menu_name}
                                        </a>
                                    )
                                ) : null}
                            </>
                        ))}

                        <NavLink key={`nav-Locations Map`} to={'/locationmap'}>
                            locations Map
                        </NavLink>
                    </Nav>
                    {UrlCheck && (
                        <div className="custom-state-city">
                            <div style={{ paddingRight: '3px' }}>
                                <img src="/assets/images/loaction_sn.png" alt="" />
                            </div>
                            <Button className="text-white" onClick={handleLocation}>
                                {cityName || locationName || 'Select Location'}
                                <span className="material-icons-outlined expand">expand_more</span>
                            </Button>
                            <LocationSelector
                                openLocation={openLocation}
                                setLocationName={setLocationName}
                                setCityName={setCityName}
                                handleLocation={handleLocation}
                            />
                        </div>
                    )}
                </div>
            </header>
            {socketDisconnect && (
                <p className="network-issue">
                    Network has been disconnected trying to reconnect... or click here to{' '}
                    <span onClick={() => window.location.reload(0)} className="network-reload">
                        reload
                    </span>
                </p>
            )}
            <SwipeableDrawer
                className="respHeaderSearch"
                anchor={'top'}
                open={state['top']}
                disableBackdropTransition={!iOS}
                disableDiscovery={iOS}
                disableSwipeToOpen={false}
                onClose={toggleDrawer('top', false)}
                onOpen={toggleDrawer('top', true)}
            >
                <div className="form-inline my-2 my-lg-0 headerSearchForm">
                    <Autocomplete
                        value={searchText}
                        detachedMediaQuery={false}
                        openOnFocus={true}
                        onSubmit={(stateData) => {
                            stateData.setIsOpen(false)
                            handleSearchAutocompleteTextChange(stateData, false)
                        }}
                        getSources={({ query }) => [
                            {
                                sourceId: 'products',
                                onSelect({ setIsOpen, setQuery, event, item }) {
                                    handleRedirectInternal(history, `productview/${item?.objectID}`)
                                },
                                getItems() {
                                    return getAlgoliaResults({
                                        searchClient,
                                        queries: [
                                            {
                                                indexName: process.env.REACT_APP_ALGOLIA_INDEX,
                                                query,
                                            },
                                        ],
                                    })
                                },

                                // templates: {
                                //     header() {
                                //         return 'Suggestions'
                                //     },
                                //     item({ item, components }) {
                                //         return (
                                //             <>
                                //                 {item?.objectID ? (
                                //                     <div className="aa-ItemTitle">
                                //                         <components.Highlight
                                //                             hit={item}
                                //                             attribute="title"
                                //                         />
                                //                     </div>
                                //                 ) : null}
                                //             </>
                                //         )
                                //     },
                                // },
                                templates: {
                                    header() {
                                        return 'Suggestions'
                                    },
                                    item({ item, components }) {
                                        return (
                                            <div className="aa-Item">
                                                {item?.objectID ? (
                                                    <div className="aa-ItemTitle">
                                                        <components.Highlight
                                                            hit={item}
                                                            attribute="title"
                                                        />
                                                    </div>
                                                ) : null}
                                            </div>
                                        )
                                    },
                                },
                            },
                        ]}
                    />
                    <Button
                        id="header_searchButton"
                        className="btn"
                        onClick={toggleDrawer('top', false)}
                    >
                        <span className="material-icons">close</span>
                    </Button>
                    {/* <input
                        className="form-control"
                        type="search"
                        placeholder="search"
                        aria-label="Search"
                        value={searchText}
                        onChange={handleSearchTextChange}
                        onKeyDown={handleSearchKeyDown}
                    />
                    <Button
                        id="header_searchButton"
                        className="btn"
                        onClick={handleSearchButtonClick}
                    >
                        <span className="material-icons">search</span>
                    </Button> */}
                </div>
            </SwipeableDrawer>

            <SwipeableDrawer
                className="headerDrawer"
                anchor={'left'}
                open={state['left']}
                disableBackdropTransition={!iOS}
                disableDiscovery={iOS}
                disableSwipeToOpen={false}
                onClose={toggleDrawer('left', false)}
                onOpen={toggleDrawer('left', true)}
            >
                <div className="headRt respNav d-flex justify-content-start align-items-center">
                    <div className="naLogoHead d-flex justify-content-between align-items-center">
                        <Link to="/">
                            <img src={FOOTER_LOGO} alt={SITE_NAME} height="47" />
                        </Link>
                        <Button
                            id="header_clear"
                            className="headDrawerClose"
                            onClick={toggleDrawer('left', false)}
                        >
                            <span className="material-icons">clear</span>
                        </Button>
                    </div>
                    <Divider />
                    <ListItem button>
                        <NavLink
                            activeClassName="active"
                            to="/my-account"
                            id="sideba-account"
                            onClick={toggleDrawer('right', false)}
                        >
                            <span className="d-flex">
                                <img src="/assets/svg/User.svg" alt="" />
                                Account
                            </span>
                        </NavLink>
                    </ListItem>
                    <ListItem button>
                        <NavLink
                            activeClassName="active"
                            to="/my-bids/all"
                            id="sidebar_mybids"
                            onClick={toggleDrawer('right', false)}
                        >
                            <span className="d-flex">
                                <img src="/assets/svg/gravel.svg" alt="" />
                                {'My Bids'}
                            </span>
                        </NavLink>
                    </ListItem>
                    <ListItem button>
                        <NavLink
                            activeClassName="active"
                            to="/shopping-cart"
                            id="sidebar-shopping-cart"
                            onClick={toggleDrawer('right', false)}
                        >
                            <span className="d-flex">
                                <img src="/assets/svg/cart-lgray.svg" alt="" />
                                Cart
                            </span>
                        </NavLink>
                    </ListItem>
                    <ListItem button>
                        <NavLink
                            activeClassName="active"
                            to="/my-orders"
                            id="sidebar-my-orders"
                            onClick={toggleDrawer('right', false)}
                        >
                            <span className="d-flex">
                                <img src="/assets/svg/orders.svg" alt="" />
                                Orders
                            </span>
                        </NavLink>
                    </ListItem>
                    <ListItem button>
                        <NavLink
                            activeClassName="active"
                            to="/watchlist/watchlist"
                            id="sidebar_favourite"
                            onClick={toggleDrawer('right', false)}
                        >
                            <img src="/assets/svg/favourite.svg" alt="" />
                            Favorites
                        </NavLink>
                    </ListItem>
                    <ListItem button>
                        <NavLink
                            activeClassName="active"
                            to="/my-interests"
                            id="sidebar-my-interests"
                            onClick={toggleDrawer('right', false)}
                        >
                            <img src="/assets/svg/ThumbsUp.svg" alt="" />
                            Interests
                        </NavLink>
                    </ListItem>
                    <ListItem button>
                        <NavLink
                            activeClassName="active"
                            to="/saved_search"
                            id="sidear_savedsearches"
                            onClick={toggleDrawer('right', false)}
                        >
                            <img src="/assets/svg/bookmark.svg" alt="" /> Saved Search
                        </NavLink>
                    </ListItem>
                    <ListItem button onClick={() => onLogOut()} id="header_logout">
                        <span className="material-icons">power_settings_new</span>
                        {'Logout'}
                    </ListItem>
                    <p className="footCopyright" dir="ltr">
                        Copyright © {new Date().getFullYear()} {SITE_URL} {'All rights reserved'}.
                    </p>
                </div>
            </SwipeableDrawer>
            <SwipeableDrawer
                className="headerDrawer dash"
                anchor={'right'}
                open={state['right']}
                disableBackdropTransition={!iOS}
                disableDiscovery={iOS}
                disableSwipeToOpen={false}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                <div className="headRt respNav d-flex justify-content-start align-items-center">
                    <div className="naLogoHead d-flex justify-content-between align-items-center">
                        <Link to="/">
                            <img src={FOOTER_LOGO} alt={SITE_NAME} height="47" />
                        </Link>
                        <Button
                            id="header_clear"
                            className="headDrawerClose"
                            onClick={toggleDrawer('right', false)}
                        >
                            <div className="mobHdr">
                                <span className="material-icons">clear</span>
                            </div>
                        </Button>
                    </div>
                    <Divider />
                    {/* <Nav
                        menuClass={`${
                            // window.location.pathname == '/search'
                            //     ? 'container-fluid'
                            // :
                            'customContainer'
                        }`}
                    >
                        {isAuthenticated && (
                            <>
                                {user?.admin ? (
                                    <NavItem key="nav-my-auction" href="/seller/auctions/open">
                                        My Auctions
                                    </NavItem>
                                ) : (
                                    authList.map((list) => (
                                        <NavLink
                                            key={`nav-${list.label}`}
                                            to={list.href}
                                            anchor={true}
                                            onClick={toggleDrawer('right', false)}
                                        >
                                            {list.label}
                                        </NavLink>
                                    ))
                                )}
                            </>
                        )}
                        {menuList.map((list) => (
                            <>
                                <NavLink
                                    key={`nav-${list.label}`}
                                    onClick={toggleDrawer('right', false)}
                                    to={list.href}
                                >
                                    {list.label}
                                </NavLink>
                            </>
                        ))}
                    </Nav> */}
                    {/* <Divider /> */}
                    {isAuthenticated ? (
                        <>
                            <ListItem
                                selected={pathLocation.pathname === '/my-account' ? true : ''}
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleClose(history, 'my-account')
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">person</span>
                                {'Account'}
                            </ListItem>
                            <ListItem
                                selected={pathLocation.pathname === '/my-orders' ? true : ''}
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleClose(history, 'my-orders')
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">assignment_return</span>
                                {'Orders & Returns'}
                            </ListItem>
                            <ListItem
                                selected={
                                    pathLocation.pathname === '/favorites/watchlist' ? true : ''
                                }
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleClose(history, 'favorites/watchlist')
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">favorite</span>
                                {'Favorites'}
                            </ListItem>
                            <ListItem
                                selected={pathLocation.pathname === '/offers/allactive' ? true : ''}
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleClose(history, 'offers/allactive')
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">sell</span>
                                {'Offers'}
                            </ListItem>
                            <ListItem
                                selected={pathLocation.pathname === 'cart' ? true : ''}
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleRedirectInternal(history, 'cart')
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">shopping_cart</span>
                                {'Cart'}
                            </ListItem>
                            <ListItem
                                selected={pathLocation.pathname === 'wallet' ? true : ''}
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleRedirectInternal(history, 'wallet')
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">account_balance_wallet</span>
                                {'Manage Credits'}
                            </ListItem>
                            <ListItem
                                selected={
                                    pathLocation.pathname === '/payments/saved_cards' ? true : ''
                                }
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleRedirectInternal(
                                                  history,
                                                  'payments/saved_cards',
                                              )
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">credit_card</span>
                                {'Manage Cards'}
                            </ListItem>
                            <ListItem
                                selected={
                                    pathLocation.pathname === '/my-account/password' ? true : ''
                                }
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleRedirectInternal(history, 'my-account/password')
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">verified_user</span>
                                {'Account Security'}
                            </ListItem>
                            <ListItem
                                selected={
                                    pathLocation.pathname === 'my-account/personal' ? true : ''
                                }
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleRedirectInternal(history, 'my-account/personal')
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">info</span>
                                {'Personal Information'}
                            </ListItem>
                            <ListItem
                                selected={
                                    pathLocation.pathname === '/my-account/notifications'
                                        ? true
                                        : ''
                                }
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleRedirectInternal(
                                                  history,
                                                  'my-account/notifications',
                                              )
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">forum</span>
                                {'Preferences'}
                            </ListItem>
                            <ListItem
                                selected={
                                    pathLocation.pathname === '/my-account/saved_search' ? true : ''
                                }
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleRedirectInternal(
                                                  history,
                                                  'my-account/saved_search',
                                              )
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">saved_search</span>
                                {'Saved Search'}
                            </ListItem>
                            <ListItem
                                selected={
                                    pathLocation.pathname === '/my-account/my-interests' ? true : ''
                                }
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleRedirectInternal(
                                                  history,
                                                  'my-account/my-interests',
                                              )
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">interests</span>
                                {'Interests'}
                            </ListItem>
                            <ListItem
                                selected={pathLocation.pathname === '/contact-us' ? true : ''}
                                button
                                onClick={
                                    () => {
                                        toggleDrawer('right', false)()
                                        handleRedirectInternal(history, 'contact-us')
                                    }

                                    // isAuthenticated
                                    //     ? () => {
                                    //           handleRedirectInternal(history, 'contact-us')
                                    //           toggleMenuDrawer()
                                    //       }
                                    //     : handleLoginPopup
                                }
                            >
                                <span className="material-icons">contact_support</span>
                                {'Contact Us'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={() => {
                                    onLogOut()
                                    toggleDrawer('right', false)()
                                }}
                                id="header_logout"
                            >
                                <span className="material-icons">logout</span>
                                Logout
                            </ListItem>
                        </>
                    ) : (
                        <>
                            <ListItem button>
                                <NavLink
                                    activeClassName="active"
                                    to="/my-account"
                                    id="sideba-account"
                                    onClick={() => {
                                        handleLoginPopup()
                                        toggleDrawer('right', false)()
                                    }}
                                >
                                    <span className="d-flex">
                                        <span className="material-icons">person</span>
                                        {/* <img src="/assets/svg/User.svg" alt="" /> */}
                                        Account
                                    </span>
                                </NavLink>
                            </ListItem>
                            <ListItem button>
                                <NavLink
                                    activeClassName="active"
                                    to="/my-orders"
                                    id="sidebar_mybids"
                                    onClick={() => {
                                        handleLoginPopup()
                                        toggleDrawer('right', false)()
                                    }}
                                >
                                    <span className="d-flex">
                                        <span className="material-icons">assignment_return</span>
                                        {'My Orders'}
                                    </span>
                                </NavLink>
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">favorite</span>
                                {'Favorites'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">sell</span>
                                {'Offers'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">shopping_cart</span>
                                {'Cart'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">account_balance_wallet</span>
                                {'Manage Credits'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">credit_card</span>
                                {'Manage Cards'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">verified_user</span>
                                {'Account Security'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">info</span>
                                {'Personal Information'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">forum</span>
                                {'Preferences'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">saved_search</span>
                                {'Saved Search'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={
                                    isAuthenticated
                                        ? () => {
                                              handleLoginPopup()
                                              toggleDrawer('right', false)()
                                          }
                                        : handleLoginPopup
                                }
                            >
                                <span className="material-icons">interests</span>
                                {'Interests'}
                            </ListItem>
                            <ListItem
                                button
                                onClick={() => {
                                    toggleDrawer('right', false)()
                                    handleRedirectInternal(history, 'contact-us')
                                }}
                            >
                                <span className="material-icons">contact_support</span>
                                {'Contact Us'}
                            </ListItem>
                        </>
                    )}
                    {/* <Divider /> */}
                    {/* <div className="mt-2 pb-4 footer-menu-list">
                        {footerData.map((data) => (
                            <FooterLinks data={data} />
                        ))}
                    </div> */}
                </div>
            </SwipeableDrawer>
            <CustomDialog
                title="Membership QR"
                open={qrCodePopup}
                disableBackdropClick
                function={changeQrPopupStatus}
                className="qrAccount"
            >
                <div className="d-flex align-items-center accProf mb-4 justify-content-around">
                    <div className="userAvatarProfile">
                        {user?.avatar ? (
                            <span className="userInitials large">
                                <img
                                    src={`${global.site_url}/uploads/avatar/${user?.avatar}`}
                                    alt="userProfile"
                                />
                            </span>
                        ) : (
                            <span className="material-icons">person</span>
                        )}
                    </div>
                    <div className="userName">
                        <h1>
                            {user?.first_name} {user?.last_name}
                        </h1>
                        <small>{user?.username}</small>
                    </div>
                </div>
                <QRCode value={user?.email?.toString() || user?.username?.toString() || ''} />
                <Link to="/" className="header-logo" id="header-logo">
                    <img src={LOGO} alt={SITE_NAME} width="157" height="47" />
                </Link>
            </CustomDialog>
        </>
    )
}
export default MobileHeader
